export type CommentModel = {
  body?: string,
  cache_key?: number,
  commentable_id: number,
  commentable_type: string,
  data?: any,
  id: number,
  public?: boolean,
  user_id: number,
}

export type CommentRequestOptions = {}

const state = {
  id: null,
  body: '',
  commentable_id: undefined,
  commentable_type: '',
  data: {},
  public: false,
  user_id: undefined,
}

export const requiredFields = [
  { key: 'body' },
  { key: 'commentable_id' },
  { key: 'commentable_type' },
]

export default state
